import React from 'react';
import WaitCube from '../../WaitCube.js'
import {_GPY, __GPYGet,__GPYPostDownload} from '../../env.js'

class UserBills extends React.Component {
  constructor(props) {
   super(props);

   this.state = {
     bills: [],
     isBillsLoaded: false,
   };
  }

  componentDidMount(){
    __GPYGet('getBills',(res) => {
       console.log(res);
       this.setState({bills:res.Bills.Bill, isBillsLoaded:true})
    });
  }

	render() {
    if(!this.state.isBillsLoaded) {
      return (<WaitCube/>);
    }

    return (
      <div className="row  justify-content-center">
           <div className="col-6 pt-2 text-center">
                 <div className="list-group">
                {this.state.bills.length===0?
                    <h5>{_GPY.i18n.get('UserBills_no_bills_yet_info')}</h5>
                  :

                 this.state.bills.map((b) => {

                   if(b.gift || b.gibt ==="true") {
                     return (  <div key={b.id} className="list-group-item list-group-item-action flex-column align-items-start">
                      <div className="row">
                        <div className="col-2"><img style={{maxWidth : '35px', maxHeight: '35px'}} src={_GPY.resource("images/gift_icon.png")} className="img-fluid" alt="Gift"/></div>
                        <div className="col-10">
                           <div className="d-flex w-100 justify-content-between"><h5 className="mb-1">Gift</h5></div>
                           <div className="d-flex w-100 justify-content-between">
                            <small>from {b.dateFrom} until {b.dateUntil}</small>
                          </div>
                       </div>
                      </div>
                     </div> )
                 } else {

                  return (<div key={b.id} className="list-group-item list-group-item-action flex-column align-items-start">
                    <div className="row">
                      <div className="col-2"><img style={{maxWidth : '70px', maxHeight: '70px'}} src={_GPY.resource("images/pdf_icon.png")} className="img-fluid" alt="PDF"/></div>
                      <div className="col-10">
                          <div className="d-flex w-100 justify-content-between">
                           <h5 className="mb-1">Invoice number: {b.billNumber}</h5>
                           <small>Invoice date: {b.billDate}</small>
                         </div>
                         <div className="d-flex w-100 justify-content-between">                          
                          <button type="button" className="btn btn-light" onClick={()=>{__GPYPostDownload("getBill",{billId:b.id,fileName:"guppyi_invoice_number_"+b.billNumber+".pdf"});}}><span className="glyphicon glyphicon-cloud-download"/> download</button>
                        </div>
                     </div>
                    </div>
                  </div>)
                  }
              })

              }
                </div>
           </div>
      </div>

		 	)
    }
}
export default UserBills;
